class gasspring_set {

    constructor(gs, mp_cyl, mp_rod) {
        this.gs = gs;
        this.mp_cyl = mp_cyl;
        this.mp_rod = mp_rod;
        this.init();
    }

    init() {
        if (!this.check_compatibility()) {
            this.length_application = 0;
            this.length_overall = 0;
            this.length_in = 0;
            this.price = 0;

            alert('These parts are not compatible.');
            return false;
        }

        this.length_application = this.gs.lengte * 1 + this.mp_rod.elongationlength * 1 + this.mp_cyl.elongationlength * 1;
        this.length_overall = this.calc_overall_length();
        // this.length_in = this.length_application * 1 - this.gs.slag * 1;

        this.price = config_price_ex
            ? parseFloat(this.gs.price_ex * 1 + this.mp_rod.price_ex * 1 + this.mp_cyl.price_ex * 1).toFixed(2)
            : parseFloat(this.gs.price * 1 + this.mp_rod.price * 1 + this.mp_cyl.price * 1).toFixed(2);

        if (this.gs.type === 'gastrekveer') {
            this.set_current_stroke(0);
        } else {
            this.set_current_stroke(this.gs.slag * 1);
        }

        this.previous_stroke = this.current_stroke;
        this.moving_out = 0;
        this.current_friction_force = 0;
    }

    /*
    When the stroke of the gas spring is set, other things like the force is calculated too
     */
    set_current_stroke(stroke) {
        this.current_stroke = stroke;
        this.current_length = stroke + this.gs.lengte_huis * 1;
        this.calc_force();
        this.previous_stroke = this.current_stroke;
    }

    calc_friction_force_factor() {
        var force = fd.get().force * 1;
        var rod_dia = this.gs.stangdia * 1;

        if (!isNaN(force)) {
            var friction = [];
            friction[4] = [0.09, 8];
            friction[6] = [0.1288, 8.4798];
            friction[8] = [0.0986, 19.044];
            friction[10] = [0.0742, 21.892];
            friction[14] = [0.0874, 24.715];
            friction[20] = [0.0784, 50.094];
            friction[28] = [0.0784, 50.094];

            var A = friction[rod_dia][0];
            var B = friction[rod_dia][1];

            var fric_force = A * force + B;
            this.friction_force_factor = (1 + (fric_force / force));
        } else {
            this.friction_force_factor = 1;
        }
    }

    calc_progression_factor() {
        if (fd.get().type === 'gastrekveer') {
            this.progression_factor = ((this.gs.progressie - 1) * (this.current_stroke / this.gs.slag)) / 100 + 1; // to do
        } else {
            this.progression_factor = (this.gs.progressie * (1 - this.current_stroke / this.gs.slag)) / 100 + 1;
        }
    }

    calc_move_direction() {
        if (this.current_stroke !== this.previous_stroke) {
            this.moving_out = (this.current_stroke - this.previous_stroke) >= 0;
        }
    }

    calc_force() {
        this.calc_move_direction();
        this.calc_friction_force_factor();
        this.calc_progression_factor();

        var force_out = fd.get().force * 1;
        if ((this.moving_out && this.gs.type === 'gasveer') || (!this.moving_out && this.gs.type === 'gastrekveer')) {
            // we are moving out, so we do not add friction
            this.current_force = this.progression_factor * force_out;
            this.current_friction_force = 0;
        } else {
            // we are moving in, so we add friction
            this.current_force = this.friction_force_factor * this.progression_factor * force_out;
            this.current_friction_force = Math.round((this.friction_force_factor - 1) * this.progression_factor * force_out);
        }
        this.current_force = Math.round(this.current_force);
    }

    check_compatibility() {
        var compatible = [];
        if (this.mp_cyl.hahntype !== 'none') {
            if (this.mp_cyl.dschroefdraad === this.gs.dschroefdraad) {
                compatible.push('mp_cyl');
            }
        } else {
            compatible.push('mp_cyl');
        }

        if (this.mp_rod.hahntype !== 'none') {
            if (this.mp_rod.dschroefdraad === this.gs.dschroefdraad) {
                compatible.push('mp_rod');
            }
        } else {
            compatible.push('mp_rod');
        }

        return compatible.length === 2;
    }

    calc_overall_length() {
        var mp_cyl_length = 0;
        if (this.mp_cyl.hahntype === 'none') {
            mp_cyl_length = this.gs.lschroefdraad * 1;
        } else if (this.mp_cyl.hahntype_array.length === 1) {
            mp_cyl_length = this.mp_cyl.totallength * 1;
        } else {
            mp_cyl_length = this.mp_cyl.elongationlength * 1 + this.mp_cyl.widthmountpart2 * 1 - this.mp_cyl.deltaxmountpart2 * 1;
        }

        var mp_rod_length = 0;
        if (this.mp_rod.hahntype === 'none') {
            mp_rod_length = this.gs.lschroefdraad * 1;
        } else if (this.mp_rod.hahntype_array.length === 1) {
            mp_rod_length = this.mp_rod.totallength * 1;
        } else {
            mp_rod_length = this.mp_rod.elongationlength * 1 + this.mp_rod.widthmountpart2 * 1 - this.mp_rod.deltaxmountpart2 * 1;
        }

        return (this.gs.lengte * 1 + mp_cyl_length + mp_rod_length);
    }
}